//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonTip from './_button_tip'
import CheckPhone from './_check_phone'

import getUserInfo from '@/common/utils/getUserInfo'
import add_comments from '@/common/mixins/addComments'
import footer_btn from '../mixins/footer_btn'

import { askAuth } from '@/common/utils/getUserInfo'


export default {
    mixins: [
        add_comments,
        footer_btn
    ],
    data(){
        return{
            building_id: ''
        }
    },
    computed: {
        show_call () {
            return this.house.has_telephone
        },
        show_icon () {
            return !this.show_call || (this.is_talent_progress ? !this.show_talent_result_btn : !this.show_result_btn)
        },
        comment_count () {
            const { comment_count } = this.house
            return comment_count || 0
        },
        tip_status () {
            const RS = {
                key: 'show_rs',
                name: '摇号结果',
            }
            const REG = {
                key: 'show_reg',
                name: '复核结果',
            }
            const LPD = {
                key: 'show_lpd',
                name: '初核名单',
            }
            let rs = ''
            const check = ({ key, name}) => {
                if (this[key]) {
                    rs = name
                    return true
                }
            }
            if (this.new_mode) {
                [REG, RS, LPD].some(check)
            } else {
                [RS, REG].some(check)
            }
            return rs
        },
        status_btn () {
            if (this.new_mode && this.show_result_btn) {
                const { lottery_data_process } = this.current_house
                const TABS = [
                    {
                        key: 'show_rs',
                        name: '摇号',
                        btn_text: '摇号结果',
                        type: 'result'
                    },
                    {
                        key: 'show_reg',
                        name: '复核',
                        btn_text: '复核结果',
                        type: 'reg'
                    },
                    {
                        key: 'show_lpd',
                        name: '初核',
                        btn_text: '初核名单',
                        type: 'lpd'
                    }
                ]
                let btn
                lottery_data_process.reverse().some((text) => {
                    const is_right = TABS.some((item) => {
                        const { name, key } = item
                        if (text === name && this[key]) {
                            btn = item
                            return true
                        }
                    })
                    return is_right
                })
                return btn
            }
        },
        force_phone_auth(){
            return this.house && this.house.activities && this.house.activities.indexOf('授权手机号') > -1
        }
    },
    methods: {
        goAllComments (e) {
            this.$emit('goComments')
        },
        goConsultantByUser (e) {
            this.$sendCtmEvtLog('楼盘详情页底部联系置业顾问按钮点击')
            this.goConsultant()
        },
        goConsultant () {
            this.$emit('goConsultant')
        },
        addComment (e) {
            askAuth(e, () => {
                const { building_id } = this.$route.query
                this.goAddComment(building_id).then((can_comment) => {
                    can_comment && this.$emit('goAdd')
                })
            })
        }
    },
    monted(){
        const { building_id } = this.$route.query
        this.building_id = building_id
    },
    props: {
        is_talent_progress: Boolean,
        house: {
            type: Object
        },
        current_house: {
            type: Object
        },
        is_selling: {
            type: Boolean
        }
    },
    components: {
        ButtonTip,
        CheckPhone
    }
}
